module.exports = require('./helpers/bundle-url').getBundleURL('lIDGV') + "logo-dark.eefe0b7f.svg";